import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from '@app/core/services/auth.service';
import { LIVREUR_HOME, isLivreur } from './auth-hooks';

/**
 * Chemins ouverts à un livreur : son espace, et les pages publiques (connexion,
 * mots de passe). Tout le reste le ramène sur sa tournée du jour.
 */
const LIVREUR_ALLOWED = [
  '/custom/deliveries-today',
  '/custom/profile',
  '/login',
  '/reset-password',
  '/reinitialiser/',
  '/validate/',
  '/acces-refuse',
];

export function isAllowedForLivreur(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return LIVREUR_ALLOWED.some((p) => path === p || path.startsWith(p.endsWith('/') ? p : p + '/'));
}

/**
 * HET — le livreur ne voit que son espace.
 *
 * Côté API il n'a plus aucune permission (HetLivreurAccessSeeder) : les écrans du BO
 * lui renverraient des 403. Ce verrou évite qu'il y arrive : quelle que soit l'URL
 * (lien, favori, saisie), il est ramené sur sa tournée. Plusieurs espaces du BO
 * (skedi, kratisi…) ne sont gardés que par la connexion, un guard par route ne
 * suffirait donc pas — d'où l'écoute globale du routeur.
 */
export function provideLivreurLock(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const router = inject(Router);
    const auth = inject(AuthService);

    router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe((e) => {
        if (auth.user && isLivreur(auth) && !isAllowedForLivreur(e.url)) {
          router.navigate(LIVREUR_HOME, { replaceUrl: true });
        }
      });
  });
}
